const NotFound = () => {
  return <h1>Page Found</h1>;
};

export default NotFound;
